angular
    .module('kareo.ui.shared.directives.user.k-user-roles-table-view.k-role-permissions', [
      'kareo.ui.shared.modules.featureSet'
    ])
    .service('KRolePermissions', ['featureSet', (featureSet) => {
      
      var features = featureSet.load();

      var roles = {
        General: {
          'Manage Patient Demographics': [1, 2, 4, 5, 6],
          'Manage Patient Appointments': [1, 2, 4, 5, 6],
          'Messages': [1, 2, 4, 5, 6]
        },
        Clinical: {
          'Manage Clinical Information': [1, 2, 4, 5],
          'View Notes': [2, 4],
          'View Signed Notes': [2],
          'View Owner Notes Only': [2],
          'Send/print prescriptions': [2],
          'Manage Refills': [2, 4],
          'View labs & studies': [2, 4, 5],
          'Share labs & studies': [2, 4],
          'Review and sign results': [2, 4]
        },
        Billing: {
          'Manage charge entries': [1, 6],
          'View claims status': [1, 6],
          'View patient collections status': [1, 6],
          'Billing Analytics': [1, 7],
          'View payout report': [1, 6, 7]
        },
        Engage: {
          'Manage online profile': [1, 2, 5],
          'Manage surveys and results': [1, 2],
          'View online directory results': [1, 2, 4, 5, 6],
          'Manage patient broadcast communication': [1, 2, 4, 5],
          'Manage patient intake': [1, 2, 5]
        },
        Administration: {
          'Manage Practice Information': [1, 6],
          'Manage Insurance': [1, 6],
          'Manage User Accounts and Subscriptions': [1],
          'Manage Appointment Settings': [1, 2, 4, 5, 6],
          'Manage Clinical Settings': [1, 2],
          'Manage Demographic Import': [1, 2, 4, 5, 6],
          'Manage Clinical Import': [1, 2, 4],
          'Manage Security Policies': [1]
        }
      };

      /*
      Method is to allow future modifications of the role matrix based on feature toggles or any other logic
      */
      async function getRolePermissions() {
        var featureToggles = await features;
        
        return roles;
      };

      return {
        getRolePermissions
      };
    }])
